import { securedBankDetailsFields, type SecuredBankDetailsFields } from "../flows/buyerFunding/securedBankDetails";
import type { BuyerFundingFlowSession } from "../flows/buyerFunding/types";
import { VetoLogo } from "./VetoLogo";

const FIELD_ORDER: Array<{ key: keyof SecuredBankDetailsFields; label: string }> = [
  { key: "partyReceivingFunds", label: "Party receiving funds" },
  { key: "fileNumber", label: "File number" },
  { key: "address", label: "Address" },
  { key: "creditTo", label: "Credit to" },
  { key: "furtherCreditTo", label: "Further credit to" },
  { key: "correspondentBank", label: "Correspondent bank" },
  { key: "beneficiaryBank", label: "Beneficiary bank" }
];

export function BuyerSecuredBankDetailsDocument({ session }: { session: BuyerFundingFlowSession }) {
  const fields = securedBankDetailsFields(session);

  return (
    <article
      className="rounded-lg border border-[#d8d2c4] bg-white p-5 shadow-md"
      data-testid="secured-bank-details-preview"
    >
      <div className="flex items-center gap-3">
        <VetoLogo height={24} />
        <span className="rounded bg-[#dcfce7] px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-[#166534]">
          Secured instructions
        </span>
      </div>
      <h3 className="mt-3 text-xl font-bold text-[#0f1c2e]">Secured bank details</h3>
      <dl className="mt-4 space-y-3">
        {FIELD_ORDER.map(({ key, label }) => (
          <div key={key} className="border-b border-[#ebe6dc] pb-2">
            <dt className="text-[10px] font-bold uppercase tracking-wider text-[#596158]">{label}</dt>
            <dd className="mt-0.5 text-sm font-semibold text-[#191919]">{fields[key]}</dd>
          </div>
        ))}
      </dl>
      <p className="mt-5 rounded bg-[#2563eb] py-2.5 text-center text-xs font-bold uppercase tracking-[0.2em] text-white">
        Office-published instructions
      </p>
      <p className="mt-3 text-[10px] leading-snug text-[#596158]">
        Amount due {fields.amountDue} · {fields.paymentRail} · Memo {fields.memoRequired}
      </p>
    </article>
  );
}
